@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/breakpoints/breakpoints' as *;

.title {
  @include typography-v2-title-xl;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  border: 1px solid var(--border-soft);
  background: var(--surface-default);

  @include border-radius-r2;
}

.section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.styledModal {
  [data-modal-container] {
    display: flex;
    flex-direction: column;
    max-height: calc(100% - var(--app-header-height));
    width: calc(100% - 32px);

    @include respond-to('lg') {
      width: 600px;
    }
  }
}

.alert {
  width: 100%;
}
